import { guestMiddleware } from "@/middleware";
import Login from "@/pages/auth/login";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_login/login")({
	component: () => <Login />,
	beforeLoad: () => guestMiddleware(),
});
